<template>
  <div>
    <Navbar />
    <div class="page-title-area item-bg2">
      <div class="container">
        <div class="page-title-content">
          <h2>POS</h2>
          <p>Checkout</p>
        </div>
      </div>
    </div>

    <div class="checkout-page">
      <header>
        <button>
          <a href="/pos-store" style="color: white">Back to POS Store</a>
        </button>
        <h4>Checkout</h4>
      </header>

      <div class="checkout-container">
        <form action="" class="checkout-form">
          <div class="input-container">
            <label for="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              required
            />
          </div>

          <div class="input-container">
            <label for="name">Email Address</label>
            <input
              type="email"
              id="name"
              name="name"
              placeholder="Enter your email address"
              required
            />
          </div>

          <div class="input-container">
            <label for="name">Delivery Address</label>
            <textarea
              rows="5"
              cols="5"
              id="name"
              name="name"
              placeholder="Enter your delivery address"
              required
            />
          </div>

          <button>Place Order</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../layout/Navbar";
export default {
  name: "Checkout",
  components: {
    Navbar,
  },
};
</script>

<style scoped>
header {
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-bottom: 24px;
  padding: 20px 40px;
}

header h4 {
  font-size: 20px;
  font-weight: 600;
}

header button {
  border: none;
  background: #0d6efd;
  color: white;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  width: 100%;
  max-width: 200px;
}

.checkout-form {
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.input-container {
  display: flex;
  flex-direction: column;
}

.input-container label {
  font-weight: 600;
}

.input-container input {
  outline: none;
  border: none;
  border-bottom: 1px solid #6b728038;
  padding: 4px 0;
  width: 100%;
  height: 100%;
}

.input-container textarea {
  outline: none;
  border: none;
  border-radius: 6px;
  border: 1px solid #6b728038;
  padding: 8px;
  width: 100%;
  height: 100%;
}

.checkout-form button {
  border: none;
  background: #0d6efd;
  color: white;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
}
</style>
